import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-center" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "BIBO Commissions", -1)
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "row g-6 mb-6 align-items-end" }
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = { class: "seq-period-filter mb-0" }
const _hoisted_9 = { class: "seq-period-filter__field seq-period-filter__field--year" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "Year", -1)
const _hoisted_11 = { class: "seq-period-filter__field seq-period-filter__field--month" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "Month", -1)
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<option value=\"1\">January</option><option value=\"2\">February</option><option value=\"3\">March</option><option value=\"4\">April</option><option value=\"5\">May</option><option value=\"6\">June</option><option value=\"7\">July</option><option value=\"8\">August</option><option value=\"9\">September</option><option value=\"10\">October</option><option value=\"11\">November</option><option value=\"12\">December</option>", 12)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, "View", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_27 = { class: "col-lg-4" }
const _hoisted_28 = { class: "row g-6" }
const _hoisted_29 = { class: "col-lg-8" }
const _hoisted_30 = { class: "card seq-card h-100" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-center" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-5" }, "Commission Overview")
  ])
], -1)
const _hoisted_32 = { class: "card-body py-3" }
const _hoisted_33 = { class: "table-responsive" }
const _hoisted_34 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_35 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", null, "User"),
    /*#__PURE__*/_createVNode("th", null, "Description"),
    /*#__PURE__*/_createVNode("th", { class: "text-end pe-4" }, "Commission")
  ])
], -1)
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createVNode("td", {
  colspan: "4",
  class: "text-center text-muted py-10"
}, "No BIBO commission history found.", -1)
const _hoisted_38 = { class: "ps-4" }
const _hoisted_39 = { class: "text-muted fs-8" }
const _hoisted_40 = { class: "d-flex align-items-center" }
const _hoisted_41 = { class: "seq-row-icon seq-row-icon--blue me-3" }
const _hoisted_42 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_43 = { class: "fw-semibold text-gray-800" }
const _hoisted_44 = { class: "text-muted fs-8" }
const _hoisted_45 = { class: "fw-semibold text-gray-800" }
const _hoisted_46 = { class: "text-muted fs-8" }
const _hoisted_47 = { class: "text-end pe-4" }
const _hoisted_48 = { class: "text-muted fs-8" }
const _hoisted_49 = { class: "fw-semibold seq-trend-up" }
const _hoisted_50 = { class: "col-lg-4" }
const _hoisted_51 = { class: "card seq-card h-100" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-center" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-5" }, "Earnings Summary")
  ])
], -1)
const _hoisted_53 = { class: "card-body py-3" }
const _hoisted_54 = { class: "table-responsive" }
const _hoisted_55 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_56 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "Level"),
    /*#__PURE__*/_createVNode("th", { class: "text-end pe-4" }, "Total")
  ])
], -1)
const _hoisted_57 = { key: 0 }
const _hoisted_58 = /*#__PURE__*/_createVNode("td", {
  colspan: "2",
  class: "text-center text-muted py-10"
}, "No summary data found.", -1)
const _hoisted_59 = { class: "ps-4" }
const _hoisted_60 = { class: "fw-semibold text-gray-800" }
const _hoisted_61 = { class: "text-end pe-4" }
const _hoisted_62 = { class: "fw-semibold seq-trend-up" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_StatCard = _resolveComponent("StatCard")
  const _component_pagination = _resolveComponent("pagination")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("h3", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Chart-line1.svg" })
          ]),
          _hoisted_4
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "seq-period-filter__input",
                  placeholder: "Year",
                  name: "year",
                  readonly: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.year = $event))
                }, null, 512), [
                  [_vModelText, _ctx.year]
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createVNode("select", {
                  class: "seq-period-filter__select",
                  name: "month",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.month = $event))
                }, [
                  _hoisted_13
                ], 512), [
                  [_vModelSelect, _ctx.month]
                ])
              ]),
              _createVNode("button", {
                type: "button",
                class: "btn btn-seq-view",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadBIBOSummary()))
              }, [
                _hoisted_25,
                _hoisted_26
              ])
            ])
          ]),
          _createVNode("div", _hoisted_27, [
            _createVNode(_component_StatCard, {
              label: "BIBO Earnings This Month",
              icon: "media/icons/duotone/Shopping/Wallet2.svg",
              value: _ctx.totalcom,
              "currency-symbol": "",
              period: "",
              decimals: 2
            }, null, 8, ["value"])
          ])
        ]),
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode("div", _hoisted_32, [
                _createVNode("div", _hoisted_33, [
                  _createVNode("table", _hoisted_34, [
                    _hoisted_35,
                    _createVNode("tbody", null, [
                      (_ctx.list.length === 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_36, [
                            _hoisted_37
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                        return (_openBlock(), _createBlock("tr", { key: index }, [
                          _createVNode("td", _hoisted_38, [
                            _createVNode("span", _hoisted_39, _toDisplayString(index + 1), 1)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("div", _hoisted_40, [
                              _createVNode("span", _hoisted_41, [
                                _createVNode("span", _hoisted_42, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
                                ])
                              ]),
                              _createVNode("div", null, [
                                _createVNode("div", _hoisted_43, _toDisplayString(item.fullname.toUpperCase()), 1),
                                _createVNode("div", _hoisted_44, _toDisplayString(item.rusid), 1)
                              ])
                            ])
                          ]),
                          _createVNode("td", null, [
                            _createVNode("div", _hoisted_45, _toDisplayString(item.prod), 1),
                            _createVNode("div", _hoisted_46, _toDisplayString(item.txndte), 1)
                          ]),
                          _createVNode("td", _hoisted_47, [
                            _createVNode("div", _hoisted_48, "Level " + _toDisplayString(item.complvl), 1),
                            _createVNode("div", _hoisted_49, _toDisplayString(_ctx.numberWithCommas(item.compv)), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_50, [
            _createVNode("div", _hoisted_51, [
              _hoisted_52,
              _createVNode("div", _hoisted_53, [
                _createVNode("div", _hoisted_54, [
                  _createVNode("table", _hoisted_55, [
                    _hoisted_56,
                    _createVNode("tbody", null, [
                      (_ctx.list2.length === 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_57, [
                            _hoisted_58
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list2, (item, index) => {
                        return (_openBlock(), _createBlock("tr", { key: index }, [
                          _createVNode("td", _hoisted_59, [
                            _createVNode("div", _hoisted_60, "Level " + _toDisplayString(item.complvl), 1)
                          ]),
                          _createVNode("td", _hoisted_61, [
                            _createVNode("div", _hoisted_62, _toDisplayString(_ctx.numberWithCommas(item.total)), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_pagination, {
        pagination: _ctx.pagination,
        callback: _ctx.reorderhistory,
        options: _ctx.paginationOptions
      }, null, 8, ["pagination", "callback", "options"])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}